import Service from "../../../Services/index";
import moment from "moment";

const reportProduct = {
    namespaced: true,
    state: {
        table: [],
        sheet_product: [],
        percent_machine: {
            id: "",
            percent_quantity: "",
            percent_time: ""
        },
        Form: {
            products: [],
            sheet: null,
            machine: null,
            quantity: "",
            start_date: "",
            start_time: "",
            shift_start: null,
            end_date: "",
            end_time: "",
            shift_end: null,
            reason: "",
            user: "",
            problem: "",
            group_id: null,
            onSave: false,
            receive_sheet: "",
            product_real: "",
            quantity_for_machine: "",
            time_shot: "",
        },
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        },
        search: {
            code: "",
            date: "",
            machine: ""
        },

    },
    mutations: {
        GET_REPORT_PRODUCT: (state, res) => {
            state.table = res.data;
            state.dataPaginate = {
                current_page: res.current_page,
                from: res.form,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            };
        },
        GET_SHEET_BY_PRODUCT: (state, res) => {
            let var_null = {
                'id': null,
                'name': 'ไม่เลือกชีท',
                'code': ''
            }
            state.sheet_product = res;
            state.sheet_product.unshift(var_null);
        },
        SET_REPORT_FORM: (state, res) => {
            //console.log(res)
            state.Form = res;
            //console.log(state)
        },
        SET_MACHINE_PERCENT: (state, res) => {
            if (res) {
                state.percent_machine = res;
            } else {
                state.percent_machine = {
                    id: "",
                    percent_quantity: "",
                    percent_time: ""
                }
            }
        },
        CLEAR_FORM_DATA: state => {
            const currentDate = moment().format("YYYY-MM-DD");
            const currentTime = moment().format("HH:mm");
            state.Form = {
                products: [],
                sheet: null,
                machine: null,
                quantity: "",
                start_date: currentDate,
                start_time: currentTime,
                shift_start: null,
                end_date: "",
                end_time: null,
                shift_end: null,
                reason: "",
                user: "",
                problem: "",
                group_id: null,
                onSave: false,
                receive_sheet: "",
                product_real: "",
                quantity_for_machine: "",
                time_shot: "",
            };
        },
        CLEAR_SEARCH: (state) => {
            state.search = {
                code: "",
                date: "",
                machine: ""
            }
        },
    },
    actions: {
        clearFormData({commit}) {
            commit("CLEAR_FORM_DATA");
        },
        get({commit}, page = 1) {
            return Service.ReportProduct.getReportProduct(page)
                .then(response => {
                    commit("GET_REPORT_PRODUCT", response);
                })
                .catch(err => {
                    console.error(err);
                });
        },
        show({commit}, id) {
            return Service.ReportProduct.showReportProduct(id)
                .then(response => {
                    commit("SET_REPORT_FORM", response);
                })
                .catch(err => {
                    console.error(err);
                });
        },
        save({commit, state}, id) {
            const data = {
                quantity: state.Form.quantity,
                start_date: state.Form.start_date,
                start_time: state.Form.start_time,
                work_start: "",
                end_date: state.Form.end_date,
                end_time: state.Form.end_time,
                work_end: "",
                reason: state.Form.reason,
                sheet_id: state.Form.sheet.id,
                machine_id: state.Form.machine.id,
                // product_id: state.Form.products.id,
                // product_code : state.Form.products.sku,
                product: state.Form.products.length > 0 ? state.Form.products[0] : state.Form.products,
                user: state.Form.user,
                problem: state.Form.problem,
                group_id: state.Form.group_id,
                receive_sheet: state.Form.receive_sheet,
                product_real: state.Form.product_real,
                quantity_for_machine: state.Form.quantity_for_machine,
                time_shot: state.Form.time_shot,
            };
            if (state.Form.shift_start) {
                data.work_start = state.Form.shift_start.id;
            }
            if (state.Form.shift_end) {
                data.work_end = state.Form.shift_end.id;
            }
            if (!id) {
                return Service.ReportProduct.createReportProduct(data).then(res => {
                    //console.log(res);
                    //console.log("create success");
                })
            } else {
                return Service.ReportProduct.updateReportProduct(id, data).then(res => {
                    //console.log(res);
                    //console.log("update success");
                })
            }
        },
        delete({commit}, id) {
            return Service.ReportProduct.deleteReportProduct(id)
                .then(() => {
                    //console.log("delete product success");
                })
                .catch(err => {
                    console.error(err);
                });
        },
        search({commit}, {page = "", code, date, machine}) {
            return Service.ReportProduct.searchReportProduct(
                page,
                code,
                date,
                machine
            )
                .then(response => {
                    commit("GET_REPORT_PRODUCT", response);
                })
                .catch(err => {
                    console.error(err);
                });
        },
        getSheetProduct({commit}, code) {
            return Service.ReportProduct.getSheetByProduct(code).then(data => {
                commit("GET_SHEET_BY_PRODUCT", data);
            })
        },
        clearSearch({commit}) {
            commit("CLEAR_SEARCH");
        },

        //machine percentR
        getMachinePercent({commit}) {
            return Service.ReportProduct.getMachinePercent().then(res => {
                commit("SET_MACHINE_PERCENT", res);
            });
        },
        saveMachinePercent({commit, state}, id) {
            if (!id) { // create
                return Service.ReportProduct.createMachinePercent(state.percent_machine).then(() => {
                    //console.log("create success");
                });
            } else { //update
                return Service.ReportProduct.updateMachinePercent(id, state.percent_machine).then(() => {
                    //console.log("update success");
                });
            }
        },
    }
};

export default reportProduct;
